module.exports = __webpack_public_path__ + "static/img/Music.d470ef0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/miximo/imgs/browse/Music.jpg
// module id = 1762
// module chunks = 0